webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SERVER_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_SERVER_URL; });
var API_SERVER_URL = "http://clk.selectmobi.com";
var SERVER_URL = window.origin;

// const API_SERVER_URL = "http://localhost:8080"
// const SERVER_URL = "http://localhost:8080";



/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  data: function data() {
    return {
      buildOn: '',
      loggedIn: true,
      snackbar: false,
      y: 'top',
      x: null,
      mode: '',
      timeout: 6000,
      text: 'Success',
      drawer: false,
      countries: [['Add/Remove Country', 'update', '/country/update']],
      advertiser: [['Add Advertiser', 'add', '/advertiser/add'], ['View Advertiser', 'list', '/advertiser/view'], ['Add Advertiser Url', 'add', '/advertiser/addUrl'], ['View Advertiser Urls', 'list', '/advertiser/viewUrls']],
      operator: [['Add Operator', 'add', '/operator/add'], ['View Operator', 'list', '/operator/view']],
      network: [['Add Network', 'add', '/network/add'], ['View Network', 'list', '/network/view'], ['Add Network Url', 'add', '/network/addUrl'], ['View Network Url', 'list', '/network/viewUrl'], ['Mannual Postback', 'send', '/network/manualPostback']],
      reports: [['Report Dashboard', 'dashboard', '/report/dashboard']],
      settings: [['Dollar', 'settings', '/setting/dollar']],
      deleteActions: [['Clicks', 'delete', '/delete/clicks'], ['Click Info', 'delete', '/delete/clickinfo']]
    };
  },

  props: {
    source: String
  },
  created: function created() {
    var _this = this;

    var vm = this;

    // To Display Operation Status.
    document.addEventListener('showSnackbarEvent', function (e) {
      vm.snackbar = true;
      vm.text = e.detail;
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/report/authorized').then(function (res) {
      if (res && res.data == 'success') {
        // LoggedIn.
        console.log("You are loggedIn.");
      } else {
        console.log("Login Required.");
        _this.loginUrl = res.request.responseURL;
        _this.loginRequired = true;
      }
    });

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/version').then(function (res) {
      vm.buildOn = res.data;
    });
  },

  methods: {
    routeHandler: function routeHandler(routeUrl) {
      this.drawer = false;
      this.$router.push(routeUrl);
    },
    goHome: function goHome() {
      this.$router.push('/');
    },
    login: function login() {
      window.location = window.origin + "/login";
    }
  }

  // {host=b1d4eb1b.ngrok.io, pragma=no-cache, cache-control=no-cache, x-wap-profile=http://218.249.47.94/Xianghe/MTK_Phone_KK_UAprofile.xml, accept=text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,*/*;q=0.8, user-agent=Mozilla/5.0 (Linux; U; Android 7.0; zh-cn; Mi-4c Build/NRD90M) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/53.0.2785.146 Mobile Safari/537.36 XiaoMi/MiuiBrowser/9.4.11, x-requested-with=com.android.browser, accept-encoding=gzip, deflate, accept-language=th-TH,en-US;q=0.8, x-forwarded-for=122.155.35.85}

});

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome To Admin Dashboard',
      loginRequired: false,
      loginUrl: ''
    };
  },
  created: function created() {
    var _this = this;

    document.title = 'Home';
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/report/authorized').then(function (res) {
      if (res && res.data == 'success') {
        // LoggedIn.
        console.log("You are loggedIn.");
      } else {
        console.log("Login Required.");
        _this.loginUrl = res.request.responseURL;
        _this.loginRequired = true;
      }
    });
  },

  methods: {
    login: function login() {
      window.location = this.loginUrl;
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      name: '',
      nameRules: [function (v) {
        return !!v || 'Name is required';
      }],
      country: '',
      status: false,
      countries: []
    };
  },
  created: function created() {
    var _this = this;

    document.title = 'Add Advertiser';
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/country/all').then(function (res) {
      res.data.forEach(function (val) {
        _this.countries.push(val.name);
      });
    });
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/advertiser/add', {
          name: this.name,
          country: this.country,
          status: this.status
        }).then(function (res) {
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Advertiser Added Successfully' });
          document.dispatchEvent(showSnackbarEvent);
          _this2.$refs.form.reset();
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: "",
      headers: [{
        text: "Adv. ID",
        value: "advertiserId",
        align: "left"
      }, {
        text: "Name",
        value: "name",
        align: "left"
      }, {
        text: "Country",
        align: "left",
        value: "country",
        sortable: false
      }, {
        text: "Status",
        value: "status",
        align: "center",
        sortable: false
      }],
      countries: [],
      advertiserList: [],

      deleteDialog: false,
      selectedAdvertiser: null
    };
  },
  created: function created() {
    var _this = this;

    document.title = 'Advertisers';
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/advertiser/all").then(function (res) {
      _this.advertiserList = res.data;
    });
  },

  methods: {
    goToAdd: function goToAdd() {
      this.$router.push("/advertiser/add");
    },
    deleteAdvertiser: function deleteAdvertiser(advertiser) {

      this.selectedAdvertiser = advertiser;
      this.deleteDialog = true;
    },
    deleteConfirmed: function deleteConfirmed() {
      var _this2 = this;

      var advertiser = this.selectedAdvertiser;
      advertiser.status = !advertiser.status;
      this.deleteDialog = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/advertiser/update", advertiser).then(function (res) {

        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Advertiser Deleted Successfully"
        });
        document.dispatchEvent(showSnackbarEvent);
        var changedIndex = _this2.advertiserList.findIndex(function (adv) {
          return adv.advertiserId === advertiser.advertiserId;
        });
        _this2.$set(_this2.advertiserList, changedIndex, advertiser);
        _this2.selectedAdvertiser = null;
      });
    }
  }
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      loading: false,

      advertiser: '',
      advertisers: [],
      advertiserNames: [],
      searchAdvertiser: null,

      country: '',
      countries: [],
      countryNames: [],
      searchCountry: null,

      operator: '',
      operators: [],
      operatorNames: [],
      searchOperator: null,

      trafficType: '',
      trafficTypes: ['A', 'C', 'I', 'IG'],
      modelType: '',
      modelTypes: ['CPA', 'CPC', 'CPM', 'CPI'],
      status: false,
      advertiserCampaignName: '',
      cpa: '',
      advertiserUrl: ''

    };
  },
  created: function created() {
    document.title = 'Add Advertiser Url';

    var vm = this;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/advertiser/all'), __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/country/all')]).then(function (results) {
      results[0].data.forEach(function (val) {
        vm.advertisers.push(val);
        vm.advertiserNames.push(val.name);
      });
      results[1].data.forEach(function (val) {
        vm.countries.push(val);
        vm.countryNames.push(val.name);
      });
    });
  },


  watch: {
    searchAdvertiser: function searchAdvertiser(val) {
      val && this.queryAdvertiserSelections(val);
    },
    searchCountry: function searchCountry(val) {
      val && this.queryCountrySelections(val);
    },
    searchOperator: function searchOperator(val) {
      val && this.queryOperatorSelections(val);
    },
    country: function country(val) {
      var vm = this;
      vm.operators = [];
      vm.operatorNames = [];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/operator/bycountry/' + val).then(function (res) {
        res.data.forEach(function (val) {
          vm.operators.push(val);
          vm.operatorNames.push(val.name);
        });
      });
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      if (this.$refs.form.validate()) {

        var selectedAdvertiser = this.advertisers.filter(function (adv) {
          return adv.name === _this.advertiser;
        });
        var selectedCountry = this.countries.filter(function (cntry) {
          return cntry.name === _this.country;
        });
        var selectedOperator = this.operators.filter(function (optor) {
          return optor.name === _this.operator;
        });

        var payload = {
          advertiserId: selectedAdvertiser[0].advertiserId,
          advertiserName: selectedAdvertiser[0].name,
          countryId: selectedCountry[0].countryId,
          countryName: selectedCountry[0].name,
          operatorId: selectedOperator[0].operatorId,
          operatorName: selectedOperator[0].name,
          trafficType: this.trafficType,
          modelType: this.modelType,
          advertiserCampaignName: this.advertiserCampaignName,
          advertiserUrl: this.advertiserUrl,
          cpa: this.cpa,
          status: this.status
        };

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/advertiser/addUrl', payload).then(function (res) {
          _this.$refs.form.reset();
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Advertiser Url Added Successfully' });
          document.dispatchEvent(showSnackbarEvent);
        });
      }
    },
    queryAdvertiserSelections: function queryAdvertiserSelections(v) {
      this.loading = true;
      this.advertiserNames = this.advertiserNames.filter(function (e) {
        return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1;
      });
      this.loading = false;
    },
    queryCountrySelections: function queryCountrySelections(v) {
      this.loading = true;
      this.countryNames = this.countryNames.filter(function (e) {
        return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1;
      });
      this.loading = false;
    },
    queryOperatorSelections: function queryOperatorSelections(v) {
      this.loading = true;
      this.operatorFilter = this.operatorNames.filter(function (e) {
        return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1;
      });
      this.loading = false;
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: "",
      headers: [{
        text: "Adv. Url ID",
        value: "advertiserUrlId",
        align: "left"
      }, {
        text: "Advertiser Name",
        value: "advertiserName",
        align: "left"
      }, {
        text: "Country Name",
        align: "left",
        value: "countryName",
        sortable: false
      }, {
        text: "Operator Name",
        align: "left",
        value: "operatorName",
        sortable: false
      }, {
        text: "Traffic Type",
        align: "left",
        value: "trafficType",
        sortable: false
      }, {
        text: "Model Type",
        align: "left",
        value: "modelType",
        sortable: false
      }, {
        text: "Campaign Name",
        align: "left",
        value: "advertiserCampaignName",
        sortable: false
      }, {
        text: "AdvertiserUrl",
        align: "left",
        value: "advertiserUrl",
        sortable: false
      }, {
        text: "CPA",
        align: "left",
        value: "cpa",
        sortable: false
      }, {
        text: "Status",
        value: "status",
        align: "center",
        sortable: false
      }],
      advertiserUrls: [],

      deleteDialog: false,
      selectedAdvertiserUrl: null

    };
  },
  created: function created() {
    var _this = this;

    document.title = 'Advertiser Urls';
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/advertiser/allUrl").then(function (res) {
      _this.advertiserUrls = res.data;
    });
  },

  methods: {
    goToAdd: function goToAdd() {
      this.$router.push("/advertiser/addurl");
    },
    deleteAdvertiserUrl: function deleteAdvertiserUrl(advertiserUrl) {
      this.selectedAdvertiserUrl = advertiserUrl;
      this.deleteDialog = true;
    },
    editAdvertiserUrl: function editAdvertiserUrl(advertiserUrl) {
      this.$router.push("/advertiser/editUrl/" + advertiserUrl.id);
    },
    deleteConfirmed: function deleteConfirmed() {
      var _this2 = this;

      var advertiserUrl = this.selectedAdvertiserUrl;

      advertiserUrl.status = !advertiserUrl.status;

      this.deleteDialog = false;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/advertiser/url/update", advertiserUrl).then(function (res) {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Advertiser Url Deleted Successfully"
        });

        document.dispatchEvent(showSnackbarEvent);
        var changedIndex = _this2.advertiserUrls.findIndex(function (advUrl) {
          return advUrl.advertiserUrlId === advertiserUrl.advertiserUrlId;
        });
        _this2.$set(_this2.advertiserUrls, changedIndex, advertiserUrl);
        _this2.selectedAdvertiserUrl = null;
      });
    }
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      loading: false,

      savedAdvUrl: null,

      advertiser: '',
      advertisers: [],
      advertiserNames: [],
      searchAdvertiser: null,

      country: '',
      countries: [],
      countryNames: [],
      searchCountry: null,

      operator: '',
      operators: [],
      operatorNames: [],
      searchOperator: null,

      trafficType: '',
      trafficTypes: ['A', 'C', 'I', 'IG'],
      modelType: '',
      modelTypes: ['CPA', 'CPC', 'CPM', 'CPI'],
      status: false,
      advertiserCampaignName: '',
      cpa: '',
      advertiserUrl: ''

    };
  },
  props: {
    savedAdvertiserUrlId: String
  },
  created: function created() {
    document.title = 'Edit Advertiser Url';
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/advertiser/all'), __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/country/all'), __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/advertiser/url/byId/' + vm.savedAdvertiserUrlId)]).then(function (results) {
      results[0].data.forEach(function (val) {
        vm.advertisers.push(val);
        vm.advertiserNames.push(val.name);
      });
      results[1].data.forEach(function (val) {
        vm.countries.push(val);
        vm.countryNames.push(val.name);
      }), vm.savedAdvUrl = results[2].data;
      if (vm.savedAdvUrl) {
        vm.advertiser = vm.savedAdvUrl.advertiserName;
        vm.country = vm.savedAdvUrl.countryName;
        vm.operator = vm.savedAdvUrl.operatorName;
        vm.advertiserCampaignName = vm.savedAdvUrl.advertiserCampaignName;
        vm.advertiserUrl = vm.savedAdvUrl.advertiserUrl;
        vm.cpa = vm.savedAdvUrl.cpa;
        vm.status = vm.savedAdvUrl.status;
      }
    });
  },


  watch: {
    searchAdvertiser: function searchAdvertiser(val) {
      val && this.queryAdvertiserSelections(val);
    },
    searchCountry: function searchCountry(val) {
      val && this.queryCountrySelections(val);
    },
    searchOperator: function searchOperator(val) {
      val && this.queryOperatorSelections(val);
    },
    country: function country(val) {
      var vm = this;
      vm.operators = [];
      vm.operatorNames = [];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/operator/bycountry/' + val).then(function (res) {
        res.data.forEach(function (val) {
          vm.operators.push(val);
          vm.operatorNames.push(val.name);
        });
      });
    }
  },
  methods: {
    submit: function submit() {
      var _this = this;

      if (this.$refs.form.validate()) {

        var selectedAdvertiser = this.advertisers.filter(function (adv) {
          return adv.name === _this.advertiser;
        });
        var selectedCountry = this.countries.filter(function (cntry) {
          return cntry.name === _this.country;
        });
        var selectedOperator = this.operators.filter(function (optor) {
          return optor.name === _this.operator;
        });

        var payload = {
          id: this.savedAdvUrl.id,
          advertiserUrlId: this.savedAdvUrl.advertiserUrlId,
          advertiserId: selectedAdvertiser[0].advertiserId,
          advertiserName: selectedAdvertiser[0].name,
          countryId: selectedCountry[0].countryId,
          countryName: selectedCountry[0].name,
          operatorId: selectedOperator[0].operatorId,
          operatorName: selectedOperator[0].name,
          trafficType: this.savedAdvUrl.trafficType,
          modelType: this.savedAdvUrl.modelType,
          advertiserCampaignName: this.advertiserCampaignName,
          advertiserUrl: this.advertiserUrl,
          cpa: this.cpa,
          status: this.status
        };
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/advertiser/addUrl', payload).then(function (res) {
          _this.$refs.form.reset();
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Advertiser Url Updated Successfully' });
          document.dispatchEvent(showSnackbarEvent);
        });
      }
    },
    queryAdvertiserSelections: function queryAdvertiserSelections(v) {
      this.loading = true;
      this.advertiserNames = this.advertiserNames.filter(function (e) {
        return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1;
      });
      this.loading = false;
    },
    queryCountrySelections: function queryCountrySelections(v) {
      this.loading = true;
      this.countryNames = this.countryNames.filter(function (e) {
        return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1;
      });
      this.loading = false;
    },
    queryOperatorSelections: function queryOperatorSelections(v) {
      this.loading = true;
      this.operatorFilter = this.operatorNames.filter(function (e) {
        return (e || '').toLowerCase().indexOf((v || '').toLowerCase()) > -1;
      });
      this.loading = false;
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    cancel: function cancel() {
      this.$router.go(-1);
    }
  }
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      name: '',
      clickIdParameter: '',
      postbackUrl: '',
      filter: 50,
      status: false
    };
  },
  created: function created() {
    document.title = 'Add Network';
  },

  methods: {
    submit: function submit() {
      var _this = this;

      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/network/add', {
          name: this.name,
          clickIdParameter: this.clickIdParameter,
          postbackUrl: this.postbackUrl,
          filter: this.filter,
          status: this.status
        }).then(function (res) {
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Network Added Successfully' });
          document.dispatchEvent(showSnackbarEvent);
          _this.$refs.form.reset();
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: "",
      headers: [{
        text: "Network ID",
        value: "networkId",
        align: "left"
      }, {
        text: "Name",
        value: "name",
        align: "left"
      }, {
        text: "Click Id Parameter",
        align: "left",
        value: "clickIdParameter",
        sortable: false
      }, {
        text: "Postback Url",
        value: "postback",
        align: "left"
      }, {
        text: "Filter",
        value: "filter",
        align: "left"
      }, {
        text: "Status",
        value: "status",
        align: "center",
        sortable: false
      }],
      countries: [],
      networkList: [],

      deleteDialog: false,
      selectedNetwork: null
    };
  },
  created: function created() {
    var _this = this;

    document.title = 'Networks';
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/network/all").then(function (res) {
      _this.networkList = res.data;
    });
  },

  methods: {
    goToAdd: function goToAdd() {
      this.$router.push("/network/add");
    },
    deleteNetwork: function deleteNetwork(network) {
      this.selectedNetwork = network;
      this.deleteDialog = true;
    },
    deleteConfirmed: function deleteConfirmed() {
      var _this2 = this;

      var network = this.selectedNetwork;

      network.status = !network.status;

      this.deleteDialog = false;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/network/update", network).then(function (res) {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Advertiser Url Deleted Successfully"
        });

        document.dispatchEvent(showSnackbarEvent);
        var changedIndex = _this2.networkList.findIndex(function (netrk) {
          return netrk.networkId === network.networkId;
        });
        _this2.$set(_this2.networkList, changedIndex, network);
        _this2.selectedNetwork = null;
      });
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      loading: false,
      network: "",
      networks: [],
      networkNames: [],
      searchNetwork: null,

      country: "",
      countries: [],
      countryNames: [],
      searchCountry: null,

      operator: "",
      operators: [],
      operatorNames: [],
      searchOperator: null,

      advertiserUrl: "",
      advertiserUrls: [],
      advertiserUrlDetails: [],
      searchAdvertiserUrl: "",

      OSType: "",
      OSTypes: ["Android", "iOS"],
      trafficType: "",
      trafficTypes: ["A", "C", "I", "IG"],
      modelType: "",
      modelTypes: ["CPA", "CPC", "CPM", "CPI"],
      payout: 0,
      status: true,

      dialog: false,
      postbackUrl: '',
      filter: 0
    };
  },
  created: function created() {
    document.title = 'Add Network Url';
    var vm = this;
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + "/network/all"), __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + "/country/all")]
    //axios.get(`${SERVER_URL}/advertiser/allUrl`)
    ).then(function (results) {
      results[0].data.forEach(function (val) {
        vm.networks.push(val);
        vm.networkNames.push(val.name);
      });
      results[1].data.forEach(function (val) {
        vm.countries.push(val);
        vm.countryNames.push(val.name);
      });
    });
  },


  watch: {
    country: function country(val) {
      var vm = this;
      vm.operators = [];
      vm.operatorNames = [];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + "/operator/bycountry/" + val).then(function (res) {
        res.data.forEach(function (val) {
          vm.operators.push(val);
          vm.operatorNames.push(val.name);
        });
      });
    },
    operator: function operator(selectedOperatorName) {
      var vm = this;
      if (!selectedOperatorName) {
        vm.advertiserUrls = [];
        vm.advertiserUrlDetails = [];
        return;
      }
      var val = this.operators.find(function (op) {
        return op.name === selectedOperatorName;
      });
      vm.advertiserUrls = [];
      vm.advertiserUrlDetails = [];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + "/advertiser/urls/byOperatorId/" + val.operatorId).then(function (res) {
        res.data.sort(vm.advUrlComparator).forEach(function (val) {
          vm.advertiserUrls.push(val);
          vm.advertiserUrlDetails.push(val.advertiserUrlId + "-" + val.advertiserCampaignName);
        });
      });
    }
  },
  methods: {
    advUrlComparator: function advUrlComparator(a, b) {
      if (a.advertiserName < b.advertiserName) return -1;
      if (a.advertiserName > b.advertiserName) return 1;
      return 0;
    },
    submitNetworkUrl: function submitNetworkUrl() {
      var _this = this;

      if (this.$refs.form.validate()) {
        var selectedNetwork = this.networks.find(function (netk) {
          return netk.name === _this.network;
        });
        this.postbackUrl = selectedNetwork.postbackUrl;
        this.filter = selectedNetwork.filter;
        this.dialog = true;
      }
    },
    submit: function submit() {
      var _this2 = this;

      if (this.$refs.form.validate()) {

        var selectedNetwork = this.networks.find(function (netk) {
          return netk.name === _this2.network;
        });

        var selectedCountry = this.countries.find(function (cntry) {
          return cntry.name === _this2.country;
        });

        var selectedOperator = this.operators.find(function (optor) {
          return optor.name === _this2.operator;
        });

        var selectedAdvertiserUrl = void 0;

        if (this.advertiserUrl) {
          var advertiserUrlId = Number(this.advertiserUrl.substring(0, this.advertiserUrl.indexOf("-")));
          selectedAdvertiserUrl = this.advertiserUrls.find(function (advUrl) {
            return advUrl.advertiserUrlId === advertiserUrlId;
          });
        }

        var payload = {

          networkId: selectedNetwork.networkId,
          networkName: selectedNetwork.name,
          clickIdParameter: selectedNetwork.clickIdParameter,
          postbackUrl: this.postbackUrl,
          filter: this.filter,

          countryId: selectedCountry.countryId,
          countryName: selectedCountry.name,

          operatorId: selectedOperator.operatorId,
          operatorName: selectedOperator.name,

          OSType: this.OSType,
          trafficType: this.trafficType,
          modelType: this.modelType,

          advertiserId: selectedAdvertiserUrl ? selectedAdvertiserUrl.advertiserId : null,
          advertiserName: selectedAdvertiserUrl ? selectedAdvertiserUrl.advertiserName : null,

          advertiserUrlId: selectedAdvertiserUrl ? selectedAdvertiserUrl.advertiserUrlId : null,
          advertiserUrl: selectedAdvertiserUrl ? selectedAdvertiserUrl.advertiserUrl : "",
          advertiserCampaignName: selectedAdvertiserUrl ? selectedAdvertiserUrl.advertiserCampaignName : "",

          payout: this.payout

        };
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + "/network/addUrl", payload).then(function (res) {
          var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
            detail: "Network Url Added Successfully"
          });
          document.dispatchEvent(showSnackbarEvent);
          _this2.$refs.form.reset();
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: "",
      headers: [{
        text: "Id",
        value: "networkUrlId",
        align: "left"
      }, {
        text: "Change Url",
        align: "center",
        value: "advertiserUrl",
        sortable: false
      }, {
        text: "Change Filter",
        align: "center",
        value: "filterChange",
        sortable: false
      }, {
        text: "Network",
        value: "networkName",
        align: "left"
      }, {
        text: "Country",
        align: "left",
        value: "countryName",
        sortable: false
      }, {
        text: "Operator",
        align: "left",
        value: "operatorName",
        sortable: false
      }, {
        text: "Traffic",
        align: "left",
        value: "trafficType",
        sortable: false
      }, {
        text: "Model",
        align: "left",
        value: "modelType",
        sortable: false
      }, {
        text: "Campaign",
        align: "left",
        value: "advertiserCampaignName",
        sortable: false
      }, {
        text: "Adv. Url",
        align: "left",
        value: "changeAdvUrl",
        sortable: false
      }, {
        text: "Payout",
        align: "left",
        value: "payout",
        sortable: false
      }, {
        text: "Status",
        value: "status",
        align: "center",
        sortable: false
      }],
      selectedNetworkUrl: null,
      networkUrls: [],

      advertiserUrl: "",
      advertiserUrls: [],
      advertiserUrlListMaster: [],
      advertiserUrlList: [],

      dialog: false,
      editDialog: false,
      deleteDialog: false,

      showOfferDetails: false,
      OfferDetails: {
        id: null,
        country: '',
        operator: '',
        url: '',
        trafficType: '',
        payout: ''
      },

      loading: false,
      searchAdvUrl: null,

      showEditFilter: false,
      changedFilter: 0,

      changedPayout: 0,
      postbackUrl: '',
      editNetworkUrlDialog: false,

      editNetworkUrlId: null,

      loadingNetworkUrlDetails: false

    };
  },

  computed: {
    getCampaignAndAdvertiserUrlId: function getCampaignAndAdvertiserUrlId() {
      return this.selectedNetworkUrl.advertiserCampaignName + "(" + this.selectedNetworkUrl.advertiserUrlId + ")";
    }
  },
  watch: {
    searchAdvUrl: function searchAdvUrl(val) {
      if (val) this.querySelections(val);
    }
  },
  created: function created() {
    document.title = 'Network Urls';
    // axios.get(`${SERVER_URL}/network/allUrl`)
    // .then(res => {
    //   if(res) {
    //     this.networkUrls = res.data;
    //   }
    // })
  },

  methods: {
    loadAllNetworkUrls: function loadAllNetworkUrls() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/network/allUrl").then(function (res) {
        if (res) {
          _this.networkUrls = res.data;
        }
      });
    },
    editNetworkUrlByNetworkUrlId: function editNetworkUrlByNetworkUrlId() {
      var _this2 = this;

      if (!this.editNetworkUrlId || isNaN(this.editNetworkUrlId)) {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Invalid/Blank Offer Id."
        });
        document.dispatchEvent(showSnackbarEvent);
        this.editNetworkUrlId = null;
        return;
      }
      this.loadingNetworkUrlDetails = true;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/network/url/" + this.editNetworkUrlId).then(function (res) {
        if (res && res.data) {
          _this2.changeAdvertiserUrl(res.data);
        } else {
          var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
            detail: "Invalid Offer Id."
          });
          document.dispatchEvent(showSnackbarEvent);
          _this2.editNetworkUrlId = null;
        }
      });

      // let netUrl = this.networkUrls.find(val => val.networkUrlId == this.editNetworkUrlId);
      // if (netUrl) {
      //   console.log("selectedNetworkUrl: ", netUrl);
      //   this.changeAdvertiserUrl(netUrl);
      // } else {
      //   console.log("No networkUrl found.");
      //   var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
      //     detail: "Invalid Network URL Id."
      //   });
      //   document.dispatchEvent(showSnackbarEvent);
      //   this.editNetworkUrlId = null;
      // }
    },
    querySelections: function querySelections(val) {
      this.advertiserUrlList = this.advertiserUrlListMaster.filter(function (advUrl) {
        return advUrl.search(new RegExp(val, 'i')) > -1;
      });
    },
    showOfferDetailsHander: function showOfferDetailsHander(networkUrl) {
      this.OfferDetails.id = networkUrl.networkUrlId;
      this.OfferDetails.country = networkUrl.countryName;
      this.OfferDetails.operator = networkUrl.operatorName;
      this.OfferDetails.url = __WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* API_SERVER_URL */] + "/api/click.php?offer_id=" + networkUrl.networkUrlId + "&aff_id=" + networkUrl.networkId + "&" + networkUrl.clickIdParameter + "=YOUR_CLICK_ID&pubid=YOUR_PUBLISHER_ID&gaid=GoogleAdvertisingID&sub1=VARIABLE1&sub2=VARIABLE2&sub3=VARIABLE3&droidid=androidID&idfa=IphoneID";
      this.OfferDetails.payout = networkUrl.payout;
      this.OfferDetails.trafficType = networkUrl.trafficType;
      this.showOfferDetails = true;
    },
    advUrlComparator: function advUrlComparator(a, b) {
      if (a.advertiserName < b.advertiserName) return -1;
      if (a.advertiserName > b.advertiserName) return 1;
      return 0;
    },
    goToAdd: function goToAdd() {
      this.$router.push("/network/addurl");
    },
    editNetworkUrl: function editNetworkUrl(networkUrl) {
      this.selectedNetworkUrl = networkUrl;
      this.editDialog = true;
    },
    updateNetworkUrl: function updateNetworkUrl() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/network/updateUrl", this.selectedNetworkUrl).then(function (res) {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Network Url Updated Successfully"
        });
        document.dispatchEvent(showSnackbarEvent);
        _this3.editDialog = true;
        var changedIndex = _this3.networkUrls.findIndex(function (netUrl) {
          return netUrl.networkUrlId === _this3.selectedNetworkUrl.networkUrlId;
        });
        _this3.$set(_this3.networkUrls, changedIndex, _this3.selectedNetworkUrl);
        _this3.selectedNetworkUrl = null;
      });
    },
    deleteNetworkUrl: function deleteNetworkUrl(networkUrl) {
      this.selectedNetworkUrl = networkUrl;
      this.deleteDialog = true;
    },
    deleteConfirmed: function deleteConfirmed() {
      var _this4 = this;

      var networkUrl = this.selectedNetworkUrl;

      networkUrl.status = !networkUrl.status;
      this.deleteDialog = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/network/url/update", networkUrl).then(function (res) {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Network Url Deleted Successfully"
        });
        document.dispatchEvent(showSnackbarEvent);
        var changedIndex = _this4.networkUrls.findIndex(function (netUrl) {
          return netUrl.networkUrlId === networkUrl.networkUrlId;
        });
        _this4.$set(_this4.networkUrls, changedIndex, networkUrl);
        _this4.selectedNetworkUrl = null;
      });
    },
    changeNetworkUrlFilter: function changeNetworkUrlFilter(networkUrl) {
      this.selectedNetworkUrl = networkUrl;
      this.changedFilter = networkUrl.filter;
      this.showEditFilter = true;
    },
    changeNetworkUrlFilterHandler: function changeNetworkUrlFilterHandler() {
      var _this5 = this;

      this.showEditFilter = false;
      if (this.selectedNetworkUrl.filter === this.changedFilter) {
        this.selectedNetworkUrl = null;
        this.changedFilter = 0;
      } else {
        var networkUrl = this.selectedNetworkUrl;
        networkUrl.filter = this.changedFilter;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/network/url/update", networkUrl).then(function (res) {
          var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
            detail: "Network Url Filter Updated Successfully"
          });
          document.dispatchEvent(showSnackbarEvent);
          var changedIndex = _this5.networkUrls.findIndex(function (netUrl) {
            return netUrl.networkUrlId === networkUrl.networkUrlId;
          });
          _this5.$set(_this5.networkUrls, changedIndex, networkUrl);
          _this5.changedFilter = 0;
          _this5.selectedNetworkUrl = null;
        });
      }
    },
    changeAdvertiserUrl: function changeAdvertiserUrl(networkUrl) {
      var _this6 = this;

      this.selectedNetworkUrl = networkUrl;
      this.advertiserUrls = [];
      this.advertiserUrlListMaster = [];
      this.advertiserUrlList.length = 0;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/advertiser/urls/byOperatorId/" + networkUrl.operatorId).then(function (res) {
        res.data.sort(_this6.advUrlComparator).forEach(function (val) {
          _this6.advertiserUrls.push(val);
          _this6.advertiserUrlListMaster.push(val.advertiserUrlId + " - " + val.advertiserCampaignName);
          _this6.advertiserUrlList.push(val.advertiserUrlId + " - " + val.advertiserCampaignName);
          _this6.dialog = true;
          _this6.loadingNetworkUrlDetails = false;
        });
      });
    },
    saveChangeUrl: function saveChangeUrl() {
      var _this7 = this;

      if (!this.advertiserUrl) {
        this.dialog = false;
        return;
      }

      var advertiserUrlId = parseInt(this.advertiserUrl.substr(0, this.advertiserUrl.indexOf(" - ")));

      var selectedAdvertiserUrl = this.advertiserUrls.find(function (advUrl) {
        return advUrl.advertiserUrlId === advertiserUrlId;
      });

      this.selectedNetworkUrl.advertiserCampaignName = selectedAdvertiserUrl.advertiserCampaignName;
      this.selectedNetworkUrl.advertiserUrlId = selectedAdvertiserUrl.advertiserUrlId;
      this.selectedNetworkUrl.advertiserUrl = selectedAdvertiserUrl.advertiserUrl;
      this.selectedNetworkUrl.advertiserId = selectedAdvertiserUrl.advertiserId;
      this.selectedNetworkUrl.advertiserName = selectedAdvertiserUrl.advertiserName;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/network/url/update", this.selectedNetworkUrl).then(function (res) {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Network Url Updated Successfully"
        });

        document.dispatchEvent(showSnackbarEvent);

        _this7.dialog = false;

        var changedIndex = _this7.networkUrls.findIndex(function (netUrl) {
          return netUrl.networkUrlId === _this7.selectedNetworkUrl.networkUrlId;
        });

        _this7.$set(_this7.networkUrls, changedIndex, _this7.selectedNetworkUrl);

        _this7.selectedNetworkUrl = null;
        _this7.advertiserUrl = "";
      });
    },
    editNetworkUrlDetails: function editNetworkUrlDetails(networkUrl) {
      this.selectedNetworkUrl = networkUrl;
      this.changedFilter = networkUrl.filter;
      this.changedPayout = networkUrl.payout;
      this.postbackUrl = networkUrl.postbackUrl;
      this.editNetworkUrlDialog = true;
    },
    updateNetowrkUrlChanges: function updateNetowrkUrlChanges() {
      var _this8 = this;

      this.editNetworkUrlDialog = false;

      var isEdited = false;

      if (this.selectedNetworkUrl.postbackUrl !== this.postbackUrl) {
        isEdited = true;
        this.selectedNetworkUrl.postbackUrl = this.postbackUrl;
      }

      if (this.selectedNetworkUrl.payout !== this.changedPayout) {
        isEdited = true;
        this.selectedNetworkUrl.payout = this.changedPayout;
      }

      if (isEdited) __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/network/url/update", this.selectedNetworkUrl).then(function (res) {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Network Url Updated Successfully"
        });

        document.dispatchEvent(showSnackbarEvent);
        _this8.dialog = false;

        var changedIndex = _this8.networkUrls.findIndex(function (netUrl) {
          return netUrl.networkUrlId === _this8.selectedNetworkUrl.networkUrlId;
        });

        _this8.$set(_this8.networkUrls, changedIndex, _this8.selectedNetworkUrl);

        _this8.selectedNetworkUrl = null;
        _this8.changedPayout = 0;
        _this8.postbackUrl = '';
      });
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      count: null,
      hour: null,
      networkUrlId: null,
      pubId: null,
      affectedClicks: [],
      headers: [{
        text: "S. No.",
        value: "serialNumber",
        align: "left",
        sortable: false
      }, {
        text: "clickId",
        value: "clickId",
        align: "left",
        sortable: false
      }, {
        text: "NetworkUrlId",
        value: "networkUrlId",
        align: "left",
        sortable: false
      }, {
        text: "PublisherId",
        value: "PublisherId",
        align: "left",
        sortable: false
      }, {
        text: "Time",
        value: "timestmap",
        align: "left",
        sortable: false
      }, {
        text: "Status",
        value: "status",
        align: "center",
        sortable: false
      }],
      showResult: false,
      showProgress: false,

      showTodaysConversion: false,
      todaysManualConversion: []
    };
  },
  created: function created() {
    document.title = 'mannual postback';
  },

  methods: {
    submit: function submit() {
      if (this.networkUrlId && this.count <= 10 && this.count > 0) {
        this.showProgress = true;
        var vm = this;
        var url = __WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/network/manual/postback?offerId=' + vm.networkUrlId + '&count=' + vm.count;
        if (vm.pubId) url = url + ('&pubId=' + vm.pubId);
        if (vm.hour) url = url + ('&hour=' + vm.hour);
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (res) {

          vm.showProgress = false;
          // vm.$refs.form.reset();

          if (res.data && res.data.length) {
            var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Conversion sent Successfully' });
            document.dispatchEvent(showSnackbarEvent);

            //vm.affectedClicks = res.data;
            res.data.forEach(function (conv, indx) {
              conv.formatedTime = vm.convertToIST(conv.clickTimestamp);
              conv.serialNumber = ++indx;
              vm.affectedClicks.push(conv);
            });
            vm.clear();
          } else {
            var _showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'No click/conversion found.' });
            document.dispatchEvent(_showSnackbarEvent);
            vm.clear();
          }
        }).catch(function (error) {
          vm.showProgress = false;
          vm.clear();
        });
      } else {
        var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Network Url Id and count(less than 10) is mandatory.' });
        document.dispatchEvent(showSnackbarEvent);
      }
    },
    loadManualConversionList: function loadManualConversionList() {
      var vm = this;
      vm.todaysManualConversion.length = 0;
      var url = __WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/network/manual/all';
      if (vm.networkUrlId) url = url + ('?offerId=' + vm.networkUrlId);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (res) {
        if (res.data && res.data.length) {
          //vm.todaysManualConversion = res.data;
          res.data.forEach(function (conv, indx) {
            conv.formatedTime = vm.convertToIST(conv.clickTimestamp);
            conv.serialNumber = ++indx;
            vm.todaysManualConversion.push(conv);
          });
          vm.showTodaysConversion = true;
        } else {
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'No manual click/conversion found.' });
          document.dispatchEvent(showSnackbarEvent);
        }
      });
    },
    convertToIST: function convertToIST(timestamp) {
      var date = new Date(timestamp);
      date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
      return date.toLocaleString();
    },
    clear: function clear() {
      this.$refs.form.reset();
      this.showTodaysConversion = false;
    }
  }

});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: false,
      name: '',
      nameRules: [function (v) {
        return !!v || 'Name is required';
      }],
      country: '',
      countryRules: [function (v) {
        return !!v || 'Country is required';
      }],
      code: '',
      iso: '',
      status: false,
      countries: [],
      countryNameList: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/country/all').then(function (res) {
      res.data.forEach(function (val) {
        _this.countries.push({ iso: val.iso, name: val.name, code: val.code });
        _this.countryNameList.push(val.name);
      });
    });
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/operator/add', {
          name: this.name,
          countryName: this.country,
          countryCode: this.code,
          countryISO: this.iso,
          status: this.status
        }).then(function (res) {
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Operator Added Successfully' });
          document.dispatchEvent(showSnackbarEvent);
          _this2.$refs.form.reset();
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    updateCountryInfo: function updateCountryInfo() {
      var _this3 = this;

      if (this.country) var ctr = this.countries.find(function (val) {
        return val.name === _this3.country;
      });
      if (ctr) this.code = ctr.code;
      if (ctr) this.iso = ctr.iso;
    }
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: "",
      headers: [{
        text: "Operator Id",
        value: "operatorId",
        align: "left"
      }, {
        text: "Name",
        value: "name",
        align: "left"
      }, {
        text: "Country Name",
        align: "left",
        value: "countryName",
        sortable: false
      }, {
        text: "Country Code",
        align: "left",
        value: "countryCode",
        sortable: false
      }, {
        text: "Country ISO",
        align: "left",
        value: "countryISO",
        sortable: false
      }, {
        text: "Status",
        value: "status",
        align: "center",
        sortable: false
      }],
      countries: [],
      operatorList: [],

      deleteDialog: false,
      selectedOperator: null

    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/operator/all").then(function (res) {
      _this.operatorList = res.data;
    });
  },

  methods: {
    goToAdd: function goToAdd() {
      this.$router.push("/operator/add");
    },
    deleteOperator: function deleteOperator(operator) {
      this.selectedOperator = operator;
      this.deleteDialog = true;
    },
    deleteConfirmed: function deleteConfirmed() {
      var _this2 = this;

      var operator = this.selectedOperator;

      operator.status = !operator.status;

      this.deleteDialog = false;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + "/operator/update", operator).then(function (res) {
        var showSnackbarEvent = new CustomEvent("showSnackbarEvent", {
          detail: "Operator Url Deleted Successfully"
        });

        document.dispatchEvent(showSnackbarEvent);
        var changedIndex = _this2.operatorList.findIndex(function (optor) {
          return optor.operatorId === operator.operatorId;
        });
        _this2.$set(_this2.operatorList, changedIndex, operator);
        _this2.selectedNetwork = null;
      });
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedCountry: '',

      dialog: false,
      search: '',
      headers: [{
        text: 'Name',
        value: 'name',
        align: 'left'
      }, {
        text: 'ISO',
        value: 'iso',
        align: 'center',
        sortable: false
      }, {
        text: 'Country Code',
        value: 'code',
        align: 'center',
        sortable: false
      }],
      countries: [],
      addedCountries: [],
      filteredCountry: [],
      countryQuery: ''
    };
  },
  created: function created() {
    var _this = this;

    document.title = 'Country';
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/country/all').then(function (res) {
      _this.addedCountries = res.data.map(function (val) {
        return { iso: val.iso, name: val.name, code: val.code };
      });
    });
  },

  watch: {
    'countryQuery': function countryQuery(val) {
      var _this2 = this;

      if (val) {
        // filter country.
        this.filteredCountry = [];
        this.countries.forEach(function (country) {
          if (country.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
            _this2.filteredCountry.push({ iso: country.iso, name: country.name, code: country.code });
          }
        });
      } else {
        // Assign with all country.
        this.filteredCountry = this.countries.map(function (country) {
          return { iso: country.iso, name: country.name, code: country.code };
        });
      }
    }
  },
  methods: {
    getNewCountry: function getNewCountry() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('https://restcountries.eu/rest/v2/all').then(function (res) {
        res.data.forEach(function (val) {
          _this3.countries.push({ iso: val.alpha2Code, name: val.name, code: val.callingCodes[0] });
          _this3.filteredCountry.push({ iso: val.alpha2Code, name: val.name, code: val.callingCodes[0] });
        });
      });
    },
    addNewCountry: function addNewCountry() {

      var vm = this;
      if (!vm.selectedCountry) {
        document.dispatchEvent(new CustomEvent('showSnackbarEvent', { detail: 'Please select at least one country from list.' }));
      } else if (this.addedCountries.find(function (ac) {
        return ac.iso == vm.selectedCountry.iso;
      })) {
        document.dispatchEvent(new CustomEvent('showSnackbarEvent', { detail: 'Country already added.' }));
        vm.dialog = false;
      } else {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/country/add', {
          name: vm.selectedCountry.name,
          code: vm.selectedCountry.code,
          iso: vm.selectedCountry.iso,
          status: 'Active'
        }).then(function (res) {
          vm.addedCountries.push({ iso: res.data.iso, name: res.data.name, code: res.data.code });
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Country added successfylly.' });
          document.dispatchEvent(showSnackbarEvent);
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(2);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {

      startDatePicker: false,
      endDatePicker: false,
      startDate: '',
      endDate: '',

      networkUrlId: null,
      publisherId: '',

      trafficType: [],
      trafficTypes: ['A', 'C', 'I', 'IG'],

      modelType: [],
      modelTypes: ['CPA', 'CPC', 'CPM', 'CPI'],

      clickHour: [],
      clickHours: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],

      country: [],
      countries: [],
      countryNames: [],
      searchCountry: null,

      operator: [],
      operators: [],
      operatorNames: [],
      searchOperator: null,

      advertiser: [],
      advertisers: [],
      searchAdvertiser: null,
      advertiserNames: [],

      network: [],
      networks: [],
      networkNames: [],

      advertiserUrlIdName: [],
      advertiserUrlIds: [],
      advertiserUrlIdNames: [],

      groupBy: 'NetworkUrl',
      selectedGroupBy: 'NetworkUrl',
      groupByList: ['Hour', 'Country', 'Operator', 'Network', 'NetworkUrl', 'Advertiser', 'AdvertiserUrl', 'Publisher'],

      headers: [{ text: 'GroupBy(Id)', value: 'id', sortable: false }, { text: 'Network', value: 'network', sortable: false }, { text: 'Country', value: 'country', sortable: false }, { text: 'Operator', value: 'operator', sortable: false }, { text: 'Advertiser', value: 'advertiser', sortable: false }, { text: 'CampaignName', value: 'CampaignName', sortable: false }, { text: 'Total Clicks', value: 'totalClicks' }, { text: 'Conv. In', value: 'conversionIn' }, { text: 'Conv. Out', value: 'conversionOut' }, { text: 'CR In', value: 'crIn' }, { text: 'CR Out', value: 'crOut' }, { text: 'ECPM', value: 'cepm' }, { text: 'Total Cost($)', value: 'totalCost' }, { text: 'Revenu($)', value: 'revenue' }, { text: 'Profit($)', value: 'profit' }],

      data: [],
      totalClicks: 0,
      totalConversionIn: 0.0,
      totalConversionOut: 0.0,
      totalEcpm: 0.0,
      totalCost: 0,
      totalRevenue: 0,
      totalProfit: 0,
      loading: false,
      noRecord: false
    };
  },

  created: function created() {
    document.title = 'Report';
    var vm = this;
    vm.dateInitializer();

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/advertiser/all'), __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/country/all'), __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/advertiser/allUrl'), __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/network/all')]).then(function (results) {
      results[0].data.forEach(function (val) {
        vm.advertisers.push(val);
        vm.advertiserNames.push(val.name);
      });
      results[1].data.forEach(function (val) {
        vm.countries.push(val);
        vm.countryNames.push(val.name);
      });
      results[2].data.forEach(function (val) {
        vm.advertiserUrlIds.push(val.advertiserUrlId);
        vm.advertiserUrlIdNames.push(val.advertiserUrlId + " - " + val.advertiserCampaignName);
      });
      results[3].data.forEach(function (val) {
        vm.networks.push(val);
        vm.networkNames.push(val.name);
      });
    });
  },

  watch: {
    country: function country(selection, oldSelection) {
      var vm = this;
      vm.operators = [];
      vm.operatorNames = [];
      selection.forEach(function (val) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/operator/bycountry/' + val).then(function (res) {
          res.data.forEach(function (val) {
            vm.operators.push(val);
            vm.operatorNames.push(val.name);
          });
        });
      });
    }
  },

  methods: {
    dateInitializer: function dateInitializer() {
      var today = new Date();
      this.startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      this.endDate = this.startDate;
    },
    search: function search() {
      this.loading = true;
      this.resetDataTable();
      this.selectedGroupBy = this.groupBy;

      var vm = this;

      var selectedCountries = [];
      vm.country.forEach(function (countryName) {
        selectedCountries.push(vm.countries.find(function (cntry) {
          return cntry.name === countryName;
        }));
      });

      var selectedOperators = [];
      vm.operator.forEach(function (opName) {
        selectedOperators.push(vm.operators.find(function (op) {
          return op.name === opName;
        }));
      });

      var selectedAdvertisers = [];
      vm.advertiser.forEach(function (advName) {
        selectedAdvertisers.push(vm.advertisers.find(function (adv) {
          return adv.name === advName;
        }));
      });

      var selectedNetwork = [];
      vm.network.forEach(function (netName) {
        selectedNetwork.push(vm.networks.find(function (net) {
          return net.name === netName;
        }));
      });

      var selectedAdvertiserUrlIds = [];
      vm.advertiserUrlIdName.forEach(function (advUrlIdName) {
        var advId = Number(advUrlIdName.substr(0, advUrlIdName.indexOf(' - ')));

        selectedAdvertiserUrlIds.push(vm.advertiserUrlIds.find(function (id) {
          return id === advId;
        }));
      });

      var start = new Date(this.startDate);
      start.setHours(0);
      start.setMinutes(0);
      start.setSeconds(0);

      var end = new Date(this.endDate);
      end.setHours(23);
      end.setMinutes(59);
      end.setSeconds(59);

      var payload = {
        startTimestamp: start.getTime(),
        endTimestamp: end.getTime(),
        networkUrlId: this.networkUrlId,
        publisherId: this.publisherId,
        trafficType: this.trafficType.map(function (tt) {
          return tt;
        }),
        modelType: this.modelType.map(function (mt) {
          return mt;
        }),
        clickHour: this.clickHour.map(function (ch) {
          return Number(ch);
        }),
        countryIds: selectedCountries.map(function (c) {
          return Number(c.countryId);
        }),
        operatorIds: selectedOperators.map(function (o) {
          return Number(o.operatorId);
        }),
        networkIds: selectedNetwork.map(function (n) {
          return Number(n.networkId);
        }),
        advertiserIds: selectedAdvertisers.map(function (a) {
          return Number(a.advertiserId);
        }),
        advertiserUrlIds: selectedAdvertiserUrlIds.map(function (advurid) {
          return Number(advurid);
        }),
        groupBy: this.groupBy
      };

      var url = __WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/report/generate';
      if (this.groupBy === "Publisher") url = __WEBPACK_IMPORTED_MODULE_2__constant_js__["b" /* SERVER_URL */] + '/report/bypublisher';

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, payload).then(function (res) {

        vm.data = res.data.stats;
        vm.totalClicks = res.data.totalNumberOfClicks;
        vm.totalConversionIn = res.data.totalConversionIn;
        vm.totalConversionOut = res.data.totalConversionOut;
        vm.totalEcpm = res.data.totalECPM.toFixed(2);
        vm.totalCost = res.data.totalAggregateCost.toFixed(2);
        vm.totalRevenue = res.data.totalAggregateRevenue.toFixed(2);
        vm.totalProfit = res.data.totalAggregateProfit.toFixed(2);
        vm.loading = false;
        if (!vm.data.length) {
          vm.noRecord = true;
        }
      });
    },
    resetTableHeader: function resetTableHeader() {
      this.headers = [{ text: 'GroupBy(Id)', value: 'id', sortable: false }, { text: 'Network', value: 'network', sortable: false }, { text: 'Country', value: 'country', sortable: false }, { text: 'Operator', value: 'operator', sortable: false }, { text: 'Advertiser', value: 'advertiser', sortable: false }, { text: 'CampaignName', value: 'CampaignName', sortable: false }, { text: 'Clicks', value: 'totalClicks' }, { text: 'ConvIn', value: 'conversionIn' }, { text: 'ConvOut', value: 'conversionOut' }, { text: 'CRIn', value: 'crIn' }, { text: 'CROut', value: 'crOut' }, { text: 'ECPM', value: 'cepm' }, { text: 'Cost($)', value: 'totalCost' }, { text: 'Revenu($)', value: 'revenue' }, { text: 'Profit($)', value: 'profit' }];
    },
    resetDataTable: function resetDataTable() {
      this.data = [];
      this.noRecord = false;
      this.totalClicks = 0, this.totalConversionIn = 0.0, this.totalConversionOut = 0.0, this.totalEcpm = 0.0, this.totalCost = 0, this.totalRevenue = 0, this.totalProfit = 0;
    },
    reset: function reset() {
      //this.$refs.form.reset();
      this.dateInitializer();
      this.networkUrlId = null;
      this.publisherId = "";
      this.trafficType = [];
      this.modelType = [];
      this.clickHour = [];
      this.country = [];
      this.operator = [];
      this.advertiser = [];
      this.advertiserUrlIdName = [];
      this.network = [];
      this.data = [];

      this.groupBy = 'NetworkUrl';
      this.selectedGroupBy = 'NetworkUrl';

      this.totalClicks = 0, this.totalConversionIn = 0.0, this.totalConversionOut = 0.0, this.totalEcpm = 0.0, this.totalCost = 0, this.totalRevenue = 0, this.totalProfit = 0, this.loading = false;
      this.noRecord = false;
      // this.resetTableHeader ();
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      value: 0
    };
  },
  created: function created() {
    var _this = this;

    document.title = 'Setting';
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/setting/dollar').then(function (val) {
      _this.value = val.data.value;
    });
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      if (this.$refs.form.validate()) {
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/setting/dollar', {
          value: this.value
        }).then(function (res) {
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Dollar Settings Updated Successfully' });
          document.dispatchEvent(showSnackbarEvent);
          _this2.$refs.form.reset();
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      startDateTime: '',
      endDateTime: '',
      loading: false,
      dialog: false,
      totalClicks: 0
    };
  },

  methods: {
    clear: function clear() {
      this.$refs.form.reset();
    },
    submit: function submit() {
      var _this = this;

      if (isNaN(new Date(this.startDateTime).getTime()) || isNaN(new Date(this.endDateTime).getTime())) {
        var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Please end date in 2018-09-05 23:59:59 fomate.' });
        document.dispatchEvent(showSnackbarEvent);
      } else {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/network/clicks/' + new Date(this.startDateTime).getTime() + '/' + new Date(this.endDateTime).getTime()).then(function (res) {
          _this.totalClicks = res.data;
          _this.loading = false;
          _this.dialog = true;
        });
      }
    },
    deleteCancel: function deleteCancel() {
      this.$refs.form.reset();
      this.dialog = false;
    },
    deleteClicks: function deleteClicks() {
      var _this2 = this;

      if (isNaN(new Date(this.startDateTime).getTime()) || isNaN(new Date(this.endDateTime).getTime())) {
        var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Please end date in 2018-09-05 23:59:59 fomate.' });
        document.dispatchEvent(showSnackbarEvent);
        this.loading = false;
      } else {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/network/clicks/' + new Date(this.startDateTime).getTime() + '/' + new Date(this.endDateTime).getTime()).then(function (res) {
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Total ' + res.data + ' clicks deleted successfully.' });
          document.dispatchEvent(showSnackbarEvent);
          _this2.loading = false;
          _this2.dialog = false;
          _this2.$refs.form.reset();
        });
      }
    }
  }

});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      startDateTime: '',
      endDateTime: '',
      loading: false,
      dialog: false,
      totalClicks: 0
    };
  },

  methods: {
    clear: function clear() {
      this.$refs.form.reset();
    },
    submit: function submit() {
      var _this = this;

      if (isNaN(new Date(this.startDateTime).getTime()) || isNaN(new Date(this.endDateTime).getTime())) {
        var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Please end date in 2018-09-05 23:59:59 fomate.' });
        document.dispatchEvent(showSnackbarEvent);
      } else {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/network/clickinfo/' + new Date(this.startDateTime).getTime() + '/' + new Date(this.endDateTime).getTime()).then(function (res) {
          _this.totalClicks = res.data;
          _this.loading = false;
          _this.dialog = true;
        });
      }
    },
    deleteCancel: function deleteCancel() {
      this.$refs.form.reset();
      this.dialog = false;
    },
    deleteClicks: function deleteClicks() {
      var _this2 = this;

      if (isNaN(new Date(this.startDateTime).getTime()) || isNaN(new Date(this.endDateTime).getTime())) {
        var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Please end date in 2018-09-05 23:59:59 fomate.' });
        document.dispatchEvent(showSnackbarEvent);
        this.loading = false;
      } else {
        this.loading = true;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_1__constant_js__["b" /* SERVER_URL */] + '/network/clickinfo/' + new Date(this.startDateTime).getTime() + '/' + new Date(this.endDateTime).getTime()).then(function (res) {
          var showSnackbarEvent = new CustomEvent('showSnackbarEvent', { detail: 'Total ' + res.data + ' click user info deleted successfully.' });
          document.dispatchEvent(showSnackbarEvent);
          _this2.$refs.form.reset();
          _this2.dialog = false;
          _this2.loading = false;
        });
      }
    }
  }

});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b882b00c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(92);
function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b882b00c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('v-snackbar',{attrs:{"color":"green","timeout":_vm.timeout,"top":_vm.y === 'top',"bottom":_vm.y === 'bottom',"right":_vm.x === 'right',"left":_vm.x === 'left',"multi-line":_vm.mode === 'multi-line',"vertical":_vm.mode === 'vertical'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),_c('v-btn',{attrs:{"flat":"","color":"pink"},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"fixed":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-list-tile',{on:{"click":function($event){_vm.goHome()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("home")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Home")])],1),_vm._v(" "),(_vm.loggedIn)?_c('v-list-group',{attrs:{"prepend-icon":"settings"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Admin Settings")])],1),_vm._v(" "),_c('v-list-group',{attrs:{"sub-group":"","no-action":""}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Advertiser")])],1),_vm._v(" "),_vm._l((_vm.advertiser),function(advsr,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.routeHandler(advsr[2])}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(advsr[0])}}),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{domProps:{"textContent":_vm._s(advsr[1])}})],1)],1)})],2),_vm._v(" "),_c('v-list-group',{attrs:{"sub-group":"","no-action":""}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Network")])],1),_vm._v(" "),_vm._l((_vm.network),function(nwrk,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.routeHandler(nwrk[2])}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(nwrk[0])}}),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{domProps:{"textContent":_vm._s(nwrk[1])}})],1)],1)})],2),_vm._v(" "),_c('v-list-group',{attrs:{"sub-group":"","no-action":""}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Country")])],1),_vm._v(" "),_vm._l((_vm.countries),function(admin,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.routeHandler(admin[2])}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(admin[0])}}),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{domProps:{"textContent":_vm._s(admin[1])}})],1)],1)})],2),_vm._v(" "),_c('v-list-group',{attrs:{"sub-group":"","no-action":""}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Operator")])],1),_vm._v(" "),_vm._l((_vm.operator),function(oprt,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.routeHandler(oprt[2])}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(oprt[0])}}),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{domProps:{"textContent":_vm._s(oprt[1])}})],1)],1)})],2),_vm._v(" "),_c('v-list-group',{attrs:{"sub-group":"","no-action":""}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Reports")])],1),_vm._v(" "),_vm._l((_vm.reports),function(report,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.routeHandler(report[2])}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(report[0])}}),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{domProps:{"textContent":_vm._s(report[1])}})],1)],1)})],2),_vm._v(" "),_c('v-list-group',{attrs:{"sub-group":"","no-action":""}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Settings")])],1),_vm._v(" "),_vm._l((_vm.settings),function(setting,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.routeHandler(setting[2])}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(setting[0])}}),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{domProps:{"textContent":_vm._s(setting[1])}})],1)],1)})],2),_vm._v(" "),_c('v-list-group',{attrs:{"sub-group":"","no-action":""}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-title',[_vm._v("Delete")])],1),_vm._v(" "),_vm._l((_vm.deleteActions),function(deleteAction,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.routeHandler(deleteAction[2])}}},[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(deleteAction[0])}}),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',{domProps:{"textContent":_vm._s(deleteAction[1])}})],1)],1)})],2)],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-title',[_vm._v("Deployed On- "+_vm._s(_vm.buildOn))])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"blue","dark":"","fixed":"","app":""}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_c('div',{staticStyle:{"display":"flex"}},[_c('img',{attrs:{"height":"30px","src":"/static/img/icons/icon.png"}}),_vm._v(" "),_c('h1',{staticClass:"title",staticStyle:{"margin-top":"5px","margin-left":"10px"}},[_vm._v("CLICK2MOBI")])])])],1),_vm._v(" "),_c('v-content',[_c('v-layout',[_c('v-flex',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_advertiser_AddAdvertiser__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_advertiser_ListAdvertisers__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_advertiser_AddAdvertiserUrl__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_advertiser_ListAdvertiserUrls__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_advertiser_EditAdvertiserUrl__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_network_AddNetwork__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_network_ListNetwork__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_network_AddNetworkUrl__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_network_ListNetworkUrl__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_network_ManualPostback__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_operator_AddOperator__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_operator_ListOperator__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_country_CountryMng__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_report_ReportDashboard__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_setting_Dollar__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_delete_DeleteClicks__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_delete_DeleteClickInfo__ = __webpack_require__(168);



























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/advertiser/add',
    name: 'addAdvertiser',
    component: __WEBPACK_IMPORTED_MODULE_3__components_advertiser_AddAdvertiser__["a" /* default */]
  }, {
    path: '/advertiser/view',
    name: 'listAdvertiser',
    component: __WEBPACK_IMPORTED_MODULE_4__components_advertiser_ListAdvertisers__["a" /* default */]
  }, {
    path: '/advertiser/addUrl',
    name: 'addAdvertiserUrl',
    component: __WEBPACK_IMPORTED_MODULE_5__components_advertiser_AddAdvertiserUrl__["a" /* default */]
  }, {
    path: '/advertiser/editUrl/:savedAdvertiserUrlId',
    name: 'editAdvertiserUrl',
    component: __WEBPACK_IMPORTED_MODULE_7__components_advertiser_EditAdvertiserUrl__["a" /* default */],
    props: true
  }, {
    path: '/advertiser/viewUrls',
    name: 'listAdvertiserUrls',
    component: __WEBPACK_IMPORTED_MODULE_6__components_advertiser_ListAdvertiserUrls__["a" /* default */]
  }, {
    path: '/network/add',
    name: 'addNetwork',
    component: __WEBPACK_IMPORTED_MODULE_8__components_network_AddNetwork__["a" /* default */]
  }, {
    path: '/network/view',
    name: 'listNetwork',
    component: __WEBPACK_IMPORTED_MODULE_9__components_network_ListNetwork__["a" /* default */]
  }, {
    path: '/network/addUrl',
    name: 'addNetworkUrl',
    component: __WEBPACK_IMPORTED_MODULE_10__components_network_AddNetworkUrl__["a" /* default */]
  }, {
    path: '/network/viewUrl',
    name: 'listNetworkUrl',
    component: __WEBPACK_IMPORTED_MODULE_11__components_network_ListNetworkUrl__["a" /* default */]
  }, {
    path: '/network/manualPostback',
    name: 'manualPostback',
    component: __WEBPACK_IMPORTED_MODULE_12__components_network_ManualPostback__["a" /* default */]
  }, {
    path: '/operator/add',
    name: 'addOperator',
    component: __WEBPACK_IMPORTED_MODULE_13__components_operator_AddOperator__["a" /* default */]
  }, {
    path: '/operator/view',
    name: 'listOperator',
    component: __WEBPACK_IMPORTED_MODULE_14__components_operator_ListOperator__["a" /* default */]
  }, {
    path: '/country/update',
    name: 'updateCountry',
    component: __WEBPACK_IMPORTED_MODULE_15__components_country_CountryMng__["a" /* default */]
  }, {
    path: '/report/dashboard',
    name: 'newDashboard',
    component: __WEBPACK_IMPORTED_MODULE_16__components_report_ReportDashboard__["a" /* default */]
  }, {
    path: '/setting/dollar',
    component: __WEBPACK_IMPORTED_MODULE_17__components_setting_Dollar__["a" /* default */]
  }, {
    path: '/delete/clicks',
    component: __WEBPACK_IMPORTED_MODULE_18__components_delete_DeleteClicks__["a" /* default */]
  }, {
    path: '/delete/clickinfo',
    component: __WEBPACK_IMPORTED_MODULE_19__components_delete_DeleteClickInfo__["a" /* default */]
  }]
}));

/***/ }),
/* 94 */,
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb8d4fde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(97);
function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb8d4fde"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb8d4fde_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center appcontainer"},[_c('h1',{staticClass:"display-2",staticStyle:{"margin-top":"10%","color":"deeppink"}},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),(_vm.loginRequired)?_c('v-btn',{attrs:{"large":"","color":"info"},on:{"click":_vm.login}},[_vm._v(" Login ")]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAdvertiser_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7ffc57_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAdvertiser_vue__ = __webpack_require__(99);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAdvertiser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c7ffc57_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAdvertiser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('p',{staticClass:"title text-xs-center"},[_vm._v("Add New Advertiser")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.nameRules,"label":"Advertiser Name","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.countries,"rules":[function (v) { return !!v || 'Please select country name.'; }],"label":"Select Country","persistent-hint":"","required":""},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"rules":[function (v) { return !!v || 'Please check the box to make advertiser active.'; }],"label":"Do you want to make it active?","required":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n        submit\n      ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAdvertisers_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51721df2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAdvertisers_vue__ = __webpack_require__(101);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAdvertisers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51721df2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAdvertisers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"color":"info","href":"#/advertiser/add"},on:{"click":function($event){_vm.goToAdd()}}},[_vm._v("Add Advertiser")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.advertiserList,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.advertiserId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.country))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.status? 'Active' : 'Inactive'))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteAdvertiser(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Sorry!!! No result found for your search \""+_vm._s(_vm.search)+"\".\n      ")])],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v("Do you want to change the status of the advertiser?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","outline":""},nativeOn:{"click":function($event){_vm.deleteDialog = false; _vm.selectedAdvertiser = null}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","outline":""},nativeOn:{"click":function($event){_vm.deleteConfirmed()}}},[_vm._v(" Change ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAdvertiserUrl_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638f4223_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAdvertiserUrl_vue__ = __webpack_require__(138);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAdvertiserUrl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_638f4223_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAdvertiserUrl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',{staticClass:"title text-xs-center"},[_vm._v("Add Advertiser URL")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-autocomplete',{attrs:{"items":_vm.advertiserNames,"rules":[function (v) { return !!v || 'Please select advertiser name.'; }],"label":"Select Advertiser","persistent-hint":"","required":""},model:{value:(_vm.advertiser),callback:function ($$v) {_vm.advertiser=$$v},expression:"advertiser"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.countryNames,"rules":[function (v) { return !!v || 'Please select Country name.'; }],"label":"Select Country","persistent-hint":"","required":""},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.operatorNames,"rules":[function (v) { return !!v || 'Please select Operator name.'; }],"label":"Select Operator(First select country)","persistent-hint":"","required":""},model:{value:(_vm.operator),callback:function ($$v) {_vm.operator=$$v},expression:"operator"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.trafficTypes,"rules":[function (v) { return !!v || 'Please select trafic type.'; }],"label":"Select Traffic Type","required":""},model:{value:(_vm.trafficType),callback:function ($$v) {_vm.trafficType=$$v},expression:"trafficType"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.modelTypes,"rules":[function (v) { return !!v || 'Please select model type.'; }],"label":"Select Models Type","required":""},model:{value:(_vm.modelType),callback:function ($$v) {_vm.modelType=$$v},expression:"modelType"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Please provide advertiser campaign name.'; }],"label":"Advertiser Campaign Name","required":""},model:{value:(_vm.advertiserCampaignName),callback:function ($$v) {_vm.advertiserCampaignName=$$v},expression:"advertiserCampaignName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","rules":[function (v) { return !!v || 'Please provide CPA.'; }],"label":"CPA","required":""},model:{value:(_vm.cpa),callback:function ($$v) {_vm.cpa=$$v},expression:"cpa"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Please provide advertiser Url.'; }],"label":"Advertiser Url","required":""},model:{value:(_vm.advertiserUrl),callback:function ($$v) {_vm.advertiserUrl=$$v},expression:"advertiserUrl"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"rules":[function (v) { return !!v || 'Please check the box to make advertiser Url active.'; }],"label":"Do you want to make it active?","required":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n        submit\n      ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAdvertiserUrls_vue__ = __webpack_require__(54);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae02b74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAdvertiserUrls_vue__ = __webpack_require__(140);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListAdvertiserUrls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ae02b74_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListAdvertiserUrls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"color":"info","href":"#/advertiser/addUrl"},on:{"click":function($event){_vm.goToAdd()}}},[_vm._v("Add Advertiser Url")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.advertiserUrls,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.advertiserUrlId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.advertiserName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.countryName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.operatorName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.trafficType))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.modelType))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.advertiserCampaignName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.advertiserUrl))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.cpa))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.status? 'Active' : 'Inactive'))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.editAdvertiserUrl(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteAdvertiserUrl(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Sorry!!! No result found for your search \""+_vm._s(_vm.search)+"\".\n      ")])],1)],1)],1),_vm._v(" "),(_vm.deleteDialog)?_c('v-flex',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v("Do you want to change the status of the advertiser url?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","outline":""},nativeOn:{"click":function($event){_vm.deleteDialog = false; _vm.selectedAdvertiserUrl = null}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","outline":""},nativeOn:{"click":function($event){_vm.deleteConfirmed()}}},[_vm._v("Change")])],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAdvertiserUrl_vue__ = __webpack_require__(55);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7610495a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAdvertiserUrl_vue__ = __webpack_require__(142);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditAdvertiserUrl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7610495a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditAdvertiserUrl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',{staticClass:"title text-xs-center"},[_vm._v("Update Advertiser URL")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-autocomplete',{attrs:{"items":_vm.advertiserNames,"rules":[function (v) { return !!v || 'Please select advertiser name.'; }],"label":"Select Advertiser","persistent-hint":"","required":""},model:{value:(_vm.advertiser),callback:function ($$v) {_vm.advertiser=$$v},expression:"advertiser"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.countryNames,"rules":[function (v) { return !!v || 'Please select Country name.'; }],"label":"Select Country","persistent-hint":"","required":""},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.operatorNames,"rules":[function (v) { return !!v || 'Please select Operator name.'; }],"label":"Select Operator(First select country)","persistent-hint":"","required":""},model:{value:(_vm.operator),callback:function ($$v) {_vm.operator=$$v},expression:"operator"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Please provide advertiser campaign name.'; }],"label":"Advertiser Campaign Name","required":""},model:{value:(_vm.advertiserCampaignName),callback:function ($$v) {_vm.advertiserCampaignName=$$v},expression:"advertiserCampaignName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"CPA","required":""},model:{value:(_vm.cpa),callback:function ($$v) {_vm.cpa=$$v},expression:"cpa"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Advertiser Url","required":""},model:{value:(_vm.advertiserUrl),callback:function ($$v) {_vm.advertiserUrl=$$v},expression:"advertiserUrl"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Advertiser Url Status","required":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{on:{"click":_vm.cancel}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n          Update\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNetwork_vue__ = __webpack_require__(56);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbb54cf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNetwork_vue__ = __webpack_require__(144);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNetwork_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cbb54cf6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNetwork_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',{staticClass:"title text-xs-center"},[_vm._v("Add New Network")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Network name is required'; }],"label":"Network Name","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'clickId Parameter is required'; }],"label":"Click Id Parameter","required":""},model:{value:(_vm.clickIdParameter),callback:function ($$v) {_vm.clickIdParameter=$$v},expression:"clickIdParameter"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Please provide postback url.'; }],"label":"Postback Url","required":""},model:{value:(_vm.postbackUrl),callback:function ($$v) {_vm.postbackUrl=$$v},expression:"postbackUrl"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Filter"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"rules":[function (v) { return !!v || 'Please check the box to make network active.'; }],"label":"Do you want to make it active?","required":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n        submit\n      ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListNetwork_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_351d7510_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListNetwork_vue__ = __webpack_require__(146);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListNetwork_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_351d7510_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListNetwork_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"color":"info","href":"#/network/add"},on:{"click":function($event){_vm.goToAdd()}}},[_vm._v("Add Network")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.networkList,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.networkId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.clickIdParameter))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.postbackUrl))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.filter))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.status? 'Active' : 'Inactive'))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteNetwork(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Sorry!!! No result found for your search \""+_vm._s(_vm.search)+"\".\n      ")])],1)],1)],1),_vm._v(" "),(_vm.deleteDialog)?_c('v-flex',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v("Do you want to change the status of the network?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","outline":""},nativeOn:{"click":function($event){_vm.deleteDialog = false; _vm.selectedNetwork = null}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","outline":""},nativeOn:{"click":function($event){_vm.deleteConfirmed()}}},[_vm._v("Change")])],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNetworkUrl_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06e5217c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNetworkUrl_vue__ = __webpack_require__(148);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNetworkUrl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06e5217c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNetworkUrl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md6":""}},[_c('p',{staticClass:"title text-xs-center"},[_vm._v("Add Network URL(Offer URL)")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-autocomplete',{attrs:{"items":_vm.networkNames,"rules":[function (v) { return !!v || 'Please select network name.'; }],"label":"Select Network","persistent-hint":"","required":""},model:{value:(_vm.network),callback:function ($$v) {_vm.network=$$v},expression:"network"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.countryNames,"rules":[function (v) { return !!v || 'Please select country name.'; }],"label":"Select Country","persistent-hint":"","required":""},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.operatorNames,"rules":[function (v) { return !!v || 'Please select operator name.'; }],"label":"Select Operator(select country first)","persistent-hint":"","required":""},model:{value:(_vm.operator),callback:function ($$v) {_vm.operator=$$v},expression:"operator"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.advertiserUrlDetails,"rules":[function (v) { return !!v || 'Please select advertiser url.'; }],"label":"Select Advertiser Url","persistent-hint":"","required":""},model:{value:(_vm.advertiserUrl),callback:function ($$v) {_vm.advertiserUrl=$$v},expression:"advertiserUrl"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.OSTypes,"rules":[function (v) { return !!v || 'Please select Operating System.'; }],"label":"Select OS Type"},model:{value:(_vm.OSType),callback:function ($$v) {_vm.OSType=$$v},expression:"OSType"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.trafficTypes,"rules":[function (v) { return !!v || 'Please select Traffic.'; }],"label":"Select Traffic Type"},model:{value:(_vm.trafficType),callback:function ($$v) {_vm.trafficType=$$v},expression:"trafficType"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.modelTypes,"rules":[function (v) { return !!v || 'Please select model type.'; }],"label":"Select Models Type"},model:{value:(_vm.modelType),callback:function ($$v) {_vm.modelType=$$v},expression:"modelType"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Payout($)"},model:{value:(_vm.payout),callback:function ($$v) {_vm.payout=$$v},expression:"payout"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submitNetworkUrl}},[_vm._v("\n          Add Network Url\n        ")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v("\n          If you want you can Change Postback details?\n        ")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Please provide postback url.'; }],"label":"Postback Url","required":""},model:{value:(_vm.postbackUrl),callback:function ($$v) {_vm.postbackUrl=$$v},expression:"postbackUrl"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Filter"},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1),_vm._v(" "),_c('v-card-actions',[_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog = false; _vm.submit();}}},[_vm._v("Submit")])],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListNetworkUrl_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69154395_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListNetworkUrl_vue__ = __webpack_require__(150);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListNetworkUrl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69154395_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListNetworkUrl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":"","md3":""}},[_c('v-btn',{attrs:{"href":"#/network/addUrl","color":"info"},on:{"click":function($event){_vm.goToAdd()}}},[_vm._v("Add Network Url")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left",attrs:{"xs6":"","md3":""}},[_c('v-btn',{attrs:{"color":"info"},on:{"click":_vm.loadAllNetworkUrls}},[_vm._v("Load All Offers")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticStyle:{"display":"flex","margin-left":"10px"}},[_c('v-text-field',{attrs:{"label":"Offer Id"},model:{value:(_vm.editNetworkUrlId),callback:function ($$v) {_vm.editNetworkUrlId=$$v},expression:"editNetworkUrlId"}}),_vm._v(" "),_c('v-btn',{attrs:{"small":"","fab":"","color":"info"},on:{"click":_vm.editNetworkUrlByNetworkUrlId}},[(_vm.loadingNetworkUrlDetails)?_c('v-progress-circular',{attrs:{"indeterminate":"","color":"white","size":30}}):_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")])],1)],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{staticStyle:{"margin-right":"10px"},attrs:{"append-icon":"search","label":"Search in table below...","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.networkUrls,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-right",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.showOfferDetailsHander(props.item)}}},[_vm._v(_vm._s(props.item.networkUrlId))]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.changeAdvertiserUrl(props.item)}}},[_c('v-icon',[_vm._v("link")])],1),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.changeNetworkUrlFilter(props.item)}}},[_c('a',[_vm._v(_vm._s(props.item.filter))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.networkName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.countryName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.operatorName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.trafficType))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.modelType))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.advertiserCampaignName)+"("+_vm._s(props.item.advertiserUrlId)+")")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v("\n            "+_vm._s(props.item.advertiserUrl)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.payout))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.status ? 'Active' : 'Inactive'))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.editNetworkUrlDetails(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteNetworkUrl(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Sorry!!! No result found for your search \""+_vm._s(_vm.search)+"\".\n      ")])],1)],1),_vm._v(" "),_c('v-flex',[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.editNetworkUrlDialog),callback:function ($$v) {_vm.editNetworkUrlDialog=$$v},expression:"editNetworkUrlDialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("\n            Edit Network Url\n          ")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"hide-details":"","single-line":""},model:{value:(_vm.postbackUrl),callback:function ($$v) {_vm.postbackUrl=$$v},expression:"postbackUrl"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Payout($)"},model:{value:(_vm.changedPayout),callback:function ($$v) {_vm.changedPayout=$$v},expression:"changedPayout"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.updateNetowrkUrlChanges();}}},[_vm._v("Update")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_vm._v("\n            Change Advertiser Url\n          ")]),_vm._v(" "),_c('v-card-text',[(_vm.selectedNetworkUrl)?_c('v-text-field',{attrs:{"value":_vm.selectedNetworkUrl.networkUrlId,"label":"Offer Id","disabled":""}}):_vm._e(),_vm._v(" "),(_vm.selectedNetworkUrl)?_c('v-text-field',{attrs:{"value":_vm.getCampaignAndAdvertiserUrlId,"label":"CampaignName","disabled":""}}):_vm._e(),_vm._v(" "),(_vm.selectedNetworkUrl)?_c('v-text-field',{attrs:{"value":_vm.selectedNetworkUrl.advertiserUrl,"label":"Advertiser Url","disabled":""}}):_vm._e(),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.advertiserUrlList,"search-input":_vm.searchAdvUrl,"single-line":"","hide-details":"","label":"Search Advertiser Url"},on:{"update:searchInput":function($event){_vm.searchAdvUrl=$event}},model:{value:(_vm.advertiserUrl),callback:function ($$v) {_vm.advertiserUrl=$$v},expression:"advertiserUrl"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.saveChangeUrl();}}},[_vm._v("Save")])],1)],1)],1)],1),_vm._v(" "),(_vm.deleteDialog)?_c('v-flex',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v("Do you want to change the status of the network url?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","outline":""},nativeOn:{"click":function($event){_vm.deleteDialog = false; _vm.selectedNetworkUrl = null}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","outline":""},nativeOn:{"click":function($event){_vm.deleteConfirmed()}}},[_vm._v("Change")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showOfferDetails)?_c('v-flex',[_c('v-dialog',{attrs:{"persistent":"","max-width":"450"},model:{value:(_vm.showOfferDetails),callback:function ($$v) {_vm.showOfferDetails=$$v},expression:"showOfferDetails"}},[_c('v-card',[_c('v-card-title',{staticClass:"subtitle",staticStyle:{"margin":"10px"}},[_vm._v("\n          Offer Id : "+_vm._s(_vm.OfferDetails.id)+" "),_c('br'),_vm._v("\n          Country: "+_vm._s(_vm.OfferDetails.country)+" "),_c('br'),_vm._v("\n          Operator : "+_vm._s(_vm.OfferDetails.operator)+" "),_c('br'),_vm._v("\n          Traffic Type:- "+_vm._s(_vm.OfferDetails.trafficType)),_c('br'),_vm._v("\n          payout:- "+_vm._s(_vm.OfferDetails.payout)),_c('br'),_vm._v("\n          Cap:- Open"),_c('br'),_vm._v("\n          Flow:- 1 Click"),_c('br'),_vm._v("\n          Allow:- Iframe"),_c('br'),_vm._v("\n          Offer Url : "+_vm._s(_vm.OfferDetails.url)+" "),_c('br'),_vm._v("\n          Preview Url : \n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","outline":""},nativeOn:{"click":function($event){_vm.showOfferDetails = false;}}},[_vm._v("Cancel")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showEditFilter)?_c('v-flex',[_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.showEditFilter),callback:function ($$v) {_vm.showEditFilter=$$v},expression:"showEditFilter"}},[_c('v-card',[_c('v-card-title',{staticClass:"subtitle"},[_vm._v("Change Filter Setting :     \n          "),_c('v-flex',{staticStyle:{"width":"60px"},attrs:{"shrink":""}},[_c('v-text-field',{staticClass:"mt-0",attrs:{"hide-details":"","single-line":"","type":"number"},model:{value:(_vm.changedFilter),callback:function ($$v) {_vm.changedFilter=$$v},expression:"changedFilter"}})],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-flex',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-slider',{attrs:{"thumb-label":"always"},model:{value:(_vm.changedFilter),callback:function ($$v) {_vm.changedFilter=$$v},expression:"changedFilter"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","outline":""},nativeOn:{"click":function($event){_vm.showEditFilter = false;}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","outline":""},nativeOn:{"click":function($event){_vm.changeNetworkUrlFilterHandler()}}},[_vm._v("Ok")])],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManualPostback_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476eea21_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManualPostback_vue__ = __webpack_require__(153);
function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManualPostback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476eea21_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManualPostback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('p',{staticClass:"title"},[_vm._v("Manual Conversion")]),_vm._v(" "),_c('v-form',{ref:"form",staticStyle:{"width":"100%","display":"flex"}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Network Url Id"},model:{value:(_vm.networkUrlId),callback:function ($$v) {_vm.networkUrlId=$$v},expression:"networkUrlId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"label":"Publisher Id"},model:{value:(_vm.pubId),callback:function ($$v) {_vm.pubId=$$v},expression:"pubId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Click Hour"},model:{value:(_vm.hour),callback:function ($$v) {_vm.hour=$$v},expression:"hour"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"No of Convertion"},model:{value:(_vm.count),callback:function ($$v) {_vm.count=$$v},expression:"count"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[(!_vm.showProgress)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.submit}},[_vm._v("\n          Send\n        ")]):_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}}),_vm._v(" "),_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("clear")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"margin-top":"20px"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.affectedClicks,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.serialNumber))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.clickId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.networkUrlId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.publisherId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.formatedTime))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.status))])]}}])})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-center pt-2"},[_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.loadManualConversionList()}}},[_vm._v("Today's Manual Conversions")])],1),_vm._v(" "),(_vm.showTodaysConversion)?_c('div',[_c('v-layout',{staticStyle:{"margin-top":"20px"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.todaysManualConversion,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.serialNumber))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.clickId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.networkUrlId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.publisherId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.formatedTime))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.status))])]}}])})],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddOperator_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_435979c9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddOperator_vue__ = __webpack_require__(155);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddOperator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_435979c9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddOperator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('p',{staticClass:"title text-xs-center"},[_vm._v("Add New Operator")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":_vm.nameRules,"label":"Operator Name","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.countryNameList,"rules":_vm.countryRules,"label":"Country Name","persistent-hint":"","required":""},on:{"input":_vm.updateCountryInfo},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Country Code","value":_vm.code,"disabled":""},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"ISO Code","disabled":""},model:{value:(_vm.iso),callback:function ($$v) {_vm.iso=$$v},expression:"iso"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"rules":[function (v) { return !!v || 'Please check the box to make operator active.'; }],"label":"Do you want to make it active?","required":""},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}}),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n          submit\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListOperator_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9059d06e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListOperator_vue__ = __webpack_require__(157);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListOperator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9059d06e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListOperator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-title',[_c('v-btn',{attrs:{"color":"info","href":"#/operator/add"},on:{"click":function($event){_vm.goToAdd()}}},[_vm._v("Add Operator")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.operatorList,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.operatorId))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.countryName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.countryCode))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.countryISO))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.status ? 'Active' : 'Inactive'))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){_vm.deleteOperator(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Sorry!!! No result found for your search \""+_vm._s(_vm.search)+"\".\n      ")])],1)],1)],1),_vm._v(" "),(_vm.deleteDialog)?_c('v-flex',[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"title"},[_vm._v("Do you want to change the status of the operator?")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","outline":""},nativeOn:{"click":function($event){_vm.deleteDialog = false; _vm.selectedOperator = null}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","outline":""},nativeOn:{"click":function($event){_vm.deleteConfirmed()}}},[_vm._v("Change")])],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountryMng_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1079ee88_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountryMng_vue__ = __webpack_require__(159);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CountryMng_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1079ee88_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CountryMng_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs10":"","offset-xs1":""}},[_c('v-card',[_c('v-card-title',[_c('v-dialog',{attrs:{"scrollable":"","max-width":"300px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{attrs:{"slot":"activator","color":"info","href":"#/country/update"},on:{"click":function($event){_vm.getNewCountry()}},slot:"activator"},[_vm._v("Add Country")]),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('div',[_c('h3',{staticClass:"title"},[_vm._v("Select Country")]),_vm._v(" "),_c('h5',{staticClass:"caption",attrs:{"color":"info"}},[_vm._v("Please select at least one country.")])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"300px"}},[_c('v-text-field',{attrs:{"label":"Search Country"},model:{value:(_vm.countryQuery),callback:function ($$v) {_vm.countryQuery=$$v},expression:"countryQuery"}}),_vm._v(" "),_c('v-radio-group',{attrs:{"column":""},model:{value:(_vm.selectedCountry),callback:function ($$v) {_vm.selectedCountry=$$v},expression:"selectedCountry"}},_vm._l((_vm.filteredCountry),function(cont){return _c('v-radio',{key:cont.alpha2Code,attrs:{"label":cont.name + ' - ' + cont.iso,"value":cont}})}))],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{nativeOn:{"click":function($event){_vm.dialog = false;}}},[_vm._v("Close")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.addNewCountry}},[_vm._v("Save ")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"append-icon":"search","label":"Search...","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.addedCountries,"search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.iso))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.code))])]}}])},[_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Sorry!!! No result found for your search \""+_vm._s(_vm.search)+"\".\n      ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportDashboard_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa4eddb2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportDashboard_vue__ = __webpack_require__(162);
function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aa4eddb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReportDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa4eddb2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReportDashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-form',{ref:"form"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":"","sm1":""}},[_c('v-menu',{ref:"startDatePicker",attrs:{"close-on-content-click":false,"return-value":_vm.startDate,"lazy":"","transition":"scale-transition","offset-y":""},on:{"update:returnValue":function($event){_vm.startDate=$event}},model:{value:(_vm.startDatePicker),callback:function ($$v) {_vm.startDatePicker=$$v},expression:"startDatePicker"}},[_c('v-text-field',{staticStyle:{"margin-left":"10px"},attrs:{"slot":"activator","label":"Start Date","readonly":""},slot:"activator",model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.$refs.startDatePicker.save(_vm.startDate)}},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm1":""}},[_c('v-menu',{ref:"endDatePicker",attrs:{"close-on-content-click":false,"return-value":_vm.endDate,"lazy":"","transition":"scale-transition","offset-y":""},on:{"update:returnValue":function($event){_vm.endDate=$event}},model:{value:(_vm.endDatePicker),callback:function ($$v) {_vm.endDatePicker=$$v},expression:"endDatePicker"}},[_c('v-text-field',{staticStyle:{"margin-left":"20px"},attrs:{"slot":"activator","label":"End Date","readonly":""},slot:"activator",model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.$refs.endDatePicker.save(_vm.endDate)}},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm2":""}},[_c('v-text-field',{staticStyle:{"margin-left":"10px"},attrs:{"label":"Net. Url Id"},model:{value:(_vm.networkUrlId),callback:function ($$v) {_vm.networkUrlId=$$v},expression:"networkUrlId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-text-field',{staticStyle:{"margin-left":"20px"},attrs:{"label":"PublisherId"},model:{value:(_vm.publisherId),callback:function ($$v) {_vm.publisherId=$$v},expression:"publisherId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-autocomplete',{staticStyle:{"margin-left":"20px"},attrs:{"items":_vm.networkNames,"multiple":"","label":"Network"},model:{value:(_vm.network),callback:function ($$v) {_vm.network=$$v},expression:"network"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm1":""}},[_c('v-select',{staticStyle:{"margin-left":"20px"},attrs:{"items":_vm.trafficTypes,"multiple":"","label":"Traffic"},model:{value:(_vm.trafficType),callback:function ($$v) {_vm.trafficType=$$v},expression:"trafficType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm2":""}},[_c('v-select',{staticStyle:{"margin-left":"20px"},attrs:{"items":_vm.modelTypes,"multiple":"","label":"Model"},model:{value:(_vm.modelType),callback:function ($$v) {_vm.modelType=$$v},expression:"modelType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm1":""}},[_c('v-select',{staticStyle:{"margin-left":"20px","margin-right":"10px"},attrs:{"items":_vm.clickHours,"multiple":"","label":"Hour"},model:{value:(_vm.clickHour),callback:function ($$v) {_vm.clickHour=$$v},expression:"clickHour"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-autocomplete',{staticStyle:{"margin-left":"10px"},attrs:{"items":_vm.countryNames,"multiple":"","label":"Country"},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-autocomplete',{staticStyle:{"margin-left":"20px"},attrs:{"items":_vm.operatorNames,"label":"Operator","multiple":""},model:{value:(_vm.operator),callback:function ($$v) {_vm.operator=$$v},expression:"operator"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-autocomplete',{staticStyle:{"margin-left":"20px"},attrs:{"items":_vm.advertiserNames,"multiple":"","label":"Adv. Name"},model:{value:(_vm.advertiser),callback:function ($$v) {_vm.advertiser=$$v},expression:"advertiser"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-autocomplete',{staticStyle:{"margin-left":"20px"},attrs:{"items":_vm.advertiserUrlIdNames,"multiple":"","label":"Adv. UrlId"},model:{value:(_vm.advertiserUrlIdName),callback:function ($$v) {_vm.advertiserUrlIdName=$$v},expression:"advertiserUrlIdName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-select',{staticStyle:{"margin-left":"20px","margin-right":"10px"},attrs:{"items":_vm.groupByList,"label":"Group By"},model:{value:(_vm.groupBy),callback:function ($$v) {_vm.groupBy=$$v},expression:"groupBy"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm1":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.search}},[_vm._v("Search")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm1":""}},[_c('v-btn',{on:{"click":_vm.reset}},[_vm._v("Reset")])],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":_vm.loading}}):_c('v-divider'),_vm._v(" "),(_vm.noRecord)?_c('div',{staticClass:"title text-xs-center",staticStyle:{"margin-top":"30px"}},[_c('p',[_vm._v(" No record found")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"20px"}},[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-data-table',{staticClass:"elevation-10",attrs:{"headers":_vm.headers,"items":_vm.data,"disable-initial-sort":true,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.networkName)+"("+_vm._s(props.item.networkId)+")[Payout : "+_vm._s(props.item.networkPyaout)+"]")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.countryName)+"("+_vm._s(props.item.countryId)+")")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.operatorName)+"("+_vm._s(props.item.operatorId)+")")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.advertiserName)+"("+_vm._s(props.item.advertiserId)+")")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.advertiserCampaignName)+"("+_vm._s(props.item.advertiserUrlId)+")")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totalClicks))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.conversionIn))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.conversionOut))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.crIn.toFixed(2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.crOut.toFixed(2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.ecpm.toFixed(2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totalCost.toFixed(2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.revenue.toFixed(2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.profit.toFixed(2)))])]}}])},[_c('template',{slot:"footer"},[_c('tr',[_c('td',[_c('strong',[_vm._v("Total : ")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('strong',[_vm._v(_vm._s(_vm.totalClicks))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('strong',[_vm._v(_vm._s(_vm.totalConversionIn))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('strong',[_vm._v(_vm._s(_vm.totalConversionOut))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('strong',[_vm._v(_vm._s(_vm.totalEcpm))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('strong',[_vm._v(_vm._s(_vm.totalCost))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('strong',[_vm._v(_vm._s(_vm.totalRevenue))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('strong',[_vm._v(_vm._s(_vm.totalProfit))])])])])],2)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dollar_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d6ac56_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dollar_vue__ = __webpack_require__(164);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dollar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d6ac56_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dollar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs6":"","sm4":"","md3":""}},[_c('p',{staticClass:"title text-xs-center"},[_vm._v(" Dollor Value ")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Rupee value is required'; }],"label":"Rupee Value","required":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "),_c('v-btn',{on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n        submit\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteClicks_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4a8c37c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteClicks_vue__ = __webpack_require__(167);
function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteClicks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4a8c37c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteClicks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('p',{staticClass:"title text-xs-center",staticStyle:{"margin-top":"10px"}},[_vm._v("Delete Clicks")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Pleae provide in YYYY-MM-DD HH:MM:SS formate.'; }],"label":"Start Date Time","required":""},model:{value:(_vm.startDateTime),callback:function ($$v) {_vm.startDateTime=$$v},expression:"startDateTime"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Pleae provide in YYYY-MM-DD HH:MM:SS formate.'; }],"label":"Start Date Time","required":""},model:{value:(_vm.endDateTime),callback:function ($$v) {_vm.endDateTime=$$v},expression:"endDateTime"}}),_vm._v(" "),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"disabled":_vm.loading},on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid || _vm.loading},on:{"click":_vm.submit}},[_vm._v("\n        submit\n      ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Do You Want To Delete Clicks ?")]),_vm._v(" "),_c('v-card-text',[_vm._v(" Total Clicks : "+_vm._s(_vm.totalClicks))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading},nativeOn:{"click":function($event){return _vm.deleteCancel($event)}}},[_vm._v(" No ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading || _vm.totalClicks == 0,"color":"primary"},nativeOn:{"click":function($event){return _vm.deleteClicks($event)}}},[_vm._v(" Yes ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteClickInfo_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ed48cea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteClickInfo_vue__ = __webpack_require__(170);
function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteClickInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ed48cea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteClickInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('p',{staticClass:"title text-xs-center",staticStyle:{"margin-top":"10px"}},[_vm._v("Delete Click User Info")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Pleae provide in YYYY-MM-DD HH:MM:SS formate.'; }],"label":"Start Date Time","required":""},model:{value:(_vm.startDateTime),callback:function ($$v) {_vm.startDateTime=$$v},expression:"startDateTime"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":[function (v) { return !!v || 'Pleae provide in YYYY-MM-DD HH:MM:SS formate.'; }],"label":"Start Date Time","required":""},model:{value:(_vm.endDateTime),callback:function ($$v) {_vm.endDateTime=$$v},expression:"endDateTime"}}),_vm._v(" "),(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":true}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-btn',{attrs:{"disabled":_vm.loading},on:{"click":_vm.clear}},[_vm._v("clear")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid || _vm.loading},on:{"click":_vm.submit}},[_vm._v("\n        submit\n      ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Do You Want To Delete Click User Info ?")]),_vm._v(" "),_c('v-card-text',[_vm._v(" Total Click User Info : "+_vm._s(_vm.totalClicks))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading},nativeOn:{"click":function($event){return _vm.deleteCancel($event)}}},[_vm._v(" No ")]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.loading || _vm.totalClicks == 0,"color":"primary"},nativeOn:{"click":function($event){return _vm.deleteClicks($event)}}},[_vm._v(" Yes ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 171 */,
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[68]);


// WEBPACK FOOTER //
// static/js/app.fe0f9d7d5476dc57747c.js